const CONTROLS_SHOW_TIME = 3500
const CONTROLS_FIRST_SHOW_TIME = 8500

enum CommandMessage {
  PLAY = 'player:play',
  SET_VOLUME = 'player:setVolume',
  MUTE = 'player:mute',
}

enum MessageType {
  READY = 'player:ready',
  CHANGE_STATE = 'player:changeState',
  ERROR = 'player:error',
}

enum PlayerState {
  PLAYING = 'playing',
  STOPPED = 'stopped',
  PAUSED = 'paused',
}

export { CONTROLS_SHOW_TIME, CONTROLS_FIRST_SHOW_TIME, CommandMessage, MessageType, PlayerState }
